import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; 
import svg59 from "../../../assets/svg/svg59.svg";
import svg54 from "../../../assets/svg/svg54.svg";
import svg55 from "../../../assets/svg/svg55.svg"; 
import svg56 from "../../../assets/svg/svg56.svg";
import svg57 from "../../../assets/svg/svg57.svg"; 
import { numberWithCommas } from "../../../utils";

 
function Cards({ dataCard, }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
   const url = "api/v1/collections/fetch-dashboard";
    const { data, count, loading } = useSelector((state) => ({
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    loading: state.fetch.loading[url],
  }));
 
   const svgMap = {
    svg59,
    svg54,
    svg55,
    svg56,
    svg57, 
  };
  const processedData = data?.cards && data?.cards?.map((item) => ({
    ...item,
   svg: svgMap[item.svg],
  }));

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4 mt-[1.25rem] lg:px-10 px-3">
      {processedData?.map((item, index) => (
        <div
          key={index}
          className="rounded-[.75rem] border border-[#D6E1F5] bg-[#F4F5F7] min-h-[6.25rem] p-[.5rem] flex flex-col"
        >
          <div className="flex items-center justify-between">
            <div className="scheme-card-title text-sm font-semibold text-gray-700 truncate pr-2">
              {item?.title}
            </div>
           <img src={item?.svg} alt={item?.svg} className="flex-shrink-0" />
          </div>
          <div className="scheme-card-content mt-[1.62rem] text-xl font-bold text-gray-900 break-words overflow-wrap-anywhere">
            {item?.value}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Cards;
